import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Mail, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Motion";

export const Faq = ({ config }) => {
  const email = config?.contact_email || "hello@example.com";
  const faqs = [
    {
      q: "I live with endometriosis. Is this circle for me?",
      a: "Yes — Beyond the Pain was created specifically for women living with endometriosis. Every practice is gentle, invitational and adaptable to however your body feels that morning.",
    },
    {
      q: "What if I'm having a flare or a low-energy day?",
      a: "You are welcome exactly as you are. Join from your bed or sofa, keep your camera off, lie down, skip any practice, or simply listen. Resting in the circle is still participating.",
    },
    {
      q: "Is this a medical treatment or therapy?",
      a: "No. This is a creative healing circle — not medical treatment, psychotherapy, or a substitute for the care of your doctors. It is a complementary space for expression, rest and connection.",
    },
    {
      q: "Do I need experience with art or breathwork?",
      a: "None at all. You don't need to be good at art or know anything about breathwork. Just bring yourself, an open mind, and a willingness to explore at your own pace.",
    },
    {
      q: "How do I join the workshop?",
      a: "Once your payment is verified, a confirmation email with the Zoom joining link, meeting ID and passcode is sent to your registered email address. A warm reminder with the same link arrives 24 hours before we begin.",
    },
    {
      q: "What if I cannot attend live?",
      a: `Please write to us at ${email} and we will do our best to help you with the available options.`,
    },
    {
      q: "What is the cancellation policy?",
      a: `Life with a chronic condition is unpredictable, and we keep this simple: you can cancel for a full refund up to 48 hours before the workshop begins (until 10:00 AM IST on 30 October 2026). After that, payments are non-refundable. To cancel, just email ${email} from your registered email address — refunds are issued to your original payment method via Razorpay.`,
    },
  ];

  return (
    <section id="faq" className="py-20 lg:py-32" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:px-12">
        <Reveal>
          <Eyebrow>Questions, gently answered</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-light tracking-tight text-[#262320] sm:text-4xl lg:text-5xl">
            Frequently asked questions
          </h2>
          <div className="mt-10 rounded-2xl border border-[#D9C3A3]/50 bg-white/75 p-7">
            <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#5E7D6A]">
              <Mail size={14} /> Contact
            </p>
            <a
              href={`mailto:${email}`}
              className="mt-3 block font-serif text-xl text-[#262320] underline decoration-[#E3C2BC] underline-offset-4 hover:text-[#5E7D6A]"
              data-testid="contact-email-link"
            >
              {email}
            </a>
            <p className="mt-3 text-sm text-[#6E6862]">Write to us with anything at all — we are happy to help.</p>
            <p className="mt-5 flex items-start gap-2 text-xs text-[#6E6862]">
              <ShieldCheck size={14} className="mt-0.5 shrink-0 text-[#5E7D6A]" />
              Payments are processed securely by Razorpay. Your card details never touch our servers.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-accordion-item-${i}`}
                className="mb-4 rounded-2xl border border-[#D9C3A3]/50 bg-white/75 px-6"
              >
                <AccordionTrigger className="py-6 text-left font-serif text-lg text-[#262320] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-[#6E6862]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
